<template>
  <transition name="el-fade-in">
    <div v-show="isShow" class="poster_box">
      <div class="poster">
        <div class="head">
          分享海报
          <!-- <i class="el-icon-circle-close" @click="closePoster"></i> -->
          <span class="question-close" @click="closePoster">×</span>
        </div>
            <el-scrollbar class="posterImg">
                <el-image :src="imgSrc"></el-image>
            </el-scrollbar>
        <div class="bottom">
            <img src="https://staticdn.ht-s.cn/se/ciif/2024/live/dialog-bottom-left.png" alt="">
            {{clientWidth > 570? '右键另存为图片进行分享': '长按图片保存到手机进行分享'}}
            <img src="https://staticdn.ht-s.cn/se/ciif/2024/live/dialog-bottom-right.png" alt="">
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      value: false,
      default: false,
    },
    imgSrc: {
      type: String,
      value: "",
      default: "",
    },
  },
  methods: {
    closePoster() {
      const obj = {
        event: "trk",
        ec: "popup",
        ea: "close",
        el: "close",
      };
      dataLayer.push(JSON.parse(JSON.stringify(obj)))
      this.$emit("closePoster", false);
    },
  },
  watch: {
    isShow() {
      if (this.isShow) {
        document.querySelector("body").style.overflow = "hidden";
      } else {
        document.querySelector("body").style.overflow = "scroll";
      }
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>